import { render, staticRenderFns } from "./ClassroomDetailTabMyStudents.vue?vue&type=template&id=ac5f546c&scoped=true"
import script from "./ClassroomDetailTabMyStudents.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f546c",
  null
  
)

export default component.exports